import { colors } from '@configs/styles/config'
import { SVGProps } from 'react'
import * as React from 'react'

export const InviteAndEarnIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="58"
    height="58"
    viewBox="0 0 58 58"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.0812 38.9179C17.665 37.5042 17.665 35.2059 19.0812 33.7922C20.4974 32.376 22.7908 32.376 24.207 33.7922C27.4115 36.9967 33.0036 36.9991 36.2081 33.7922L48.2649 21.7354C51.5733 18.427 51.5733 13.0427 48.2649 9.73428C44.9565 6.42586 39.5721 6.42586 36.2637 9.73428C34.8475 11.1504 32.5541 11.1504 31.138 9.73428C29.7218 8.32053 29.7218 6.02228 31.138 4.60853C37.2715 -1.52739 47.2571 -1.52739 53.3906 4.60853C59.5265 10.7444 59.5265 20.7253 53.3906 26.8612L41.3339 38.9179C38.2647 41.9871 34.2361 43.5193 30.2075 43.5193C26.179 43.5193 22.148 41.9847 19.0812 38.9179ZM15.7365 57.9927C19.7651 57.9927 23.7937 56.4581 26.8629 53.3914C28.279 51.9776 28.279 49.6794 26.8629 48.2656C25.4467 46.8494 23.1533 46.8494 21.7371 48.2656C18.4263 51.5764 13.042 51.574 9.73596 48.2656C6.42755 44.9572 6.42755 39.5729 9.73596 36.2644L21.725 24.2754C25.0359 20.9645 30.4202 20.9645 33.7262 24.2754C35.1424 25.6915 37.4358 25.6915 38.852 24.2754C40.2681 22.8616 40.2681 20.5634 38.852 19.1496C32.716 13.0137 22.7352 13.0137 16.5993 19.1496L4.6078 31.1387C-1.52812 37.2746 -1.52812 47.2554 4.6078 53.3914C7.67696 56.4605 11.708 57.9927 15.7365 57.9927Z"
      fill={props.color ? props.color : colors.uguPurple}
    />
  </svg>
)
